export default __webpack_public_path__ + "static/media/demo_4.67fe4840.jpg";